import Util from './components/util';
import Account from './components/account';
import Time from './components/time';
import Client from './components/client';
import Tracker from './components/tracker';
import Share from './components/share';
import Delivery from './components/delivery';
import URL from './components/url';
import Risk from './components/risk';
import Verify from './components/verify';
import Dashi from './components/dashi';
import Group from './components/group';
import defaultExecution from './components/defaultExecution';
if (!window.$ACE) {
  window.$ACE = {};
}
const ACE = { ...window.$ACE, Util, Account, Group, Dashi, Verify, Time, Client, Tracker, Share, Delivery, URL, Risk };
defaultExecution();
window.$ACE = ACE;
export default ACE;



// WEBPACK FOOTER //
// ./src/index.js